
import { defineComponent } from "vue";

export default defineComponent({
  name: "IssueMain",

  methods: {
    go(page: string) {
      this.$router.push(page);
    },
  },
});
